const accessibilityTypes = {
  1: "Global",
  2: "Feature",
};

export default accessibilityTypes;
